/**
 * Create random numbers
 * @param qty {Number}
 * @param min {Number}
 * @param max {Number}
 * @returns {Array}
 */
export let random = (qty, min, max) => {
  let randomNumbers = [];
  let num = 0;
  ++max;

  while (randomNumbers.length < qty) {
    num = Math.floor(Math.random() * (max - min) + min);

    if (randomNumbers.indexOf(num) < 0) {
      randomNumbers.push(num);
    }
  }

  randomNumbers.sort((a, b) => a - b);

  return randomNumbers;
};



// WEBPACK FOOTER //
// random.js